export function Ly_Next(value, index) {
    var nxt = value;
    var i = index;
    var length = nxt.length;
    var _index;
    // let part = index / length;
    if ((i + 1) < length) {
        nxt = (nxt[(i + 1)]);
        _index = i + 1;
    }
    else {
        _index = 0;
        nxt = (nxt[(0)]);
    }
    return {
        index: _index,
        next: nxt,
    };
}
//# sourceMappingURL=next.js.map